import React, { Component } from 'react';

class IconStarFull extends Component {
    render() {
        return (
            <svg
                className="mr-1"
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="none"
                viewBox="0 0 14 14"
            >
                <path
                    fill="#FFC635"
                    d="M6.137.971a1 1 0 011.726 0l1.512 2.58a1 1 0 00.648.47l2.92.641a1 1 0 01.533 1.641L11.49 8.538a1 1 0 00-.247.762l.292 2.975a1 1 0 01-1.396 1.014L7.402 12.09a1 1 0 00-.802 0L3.861 13.29a1 1 0 01-1.396-1.014L2.757 9.3a1 1 0 00-.247-.762L.524 6.303a1 1 0 01.534-1.64l2.92-.642a1 1 0 00.647-.47L6.137.97z"
                ></path>
            </svg>
        );
    }
}

export default IconStarFull;